import { Flexbox, Sizes } from '@sede-enterprise/shell-ds-react-framework';
import { Skeleton } from 'components/storybook-migration/skeleton/Skeleton';
import { DYNATRACE_ACTIONS } from 'constants/dynatrace-actions';
import {
  CardStyled,
  SuffixPrefix,
  SummaryCardMainText,
  SummaryCardWrapper,
} from 'pages/Optimisation/components/SummaryCards/SummaryCard.styled';
import { SummaryCardTitle } from 'pages/Optimisation/components/SummaryCards/SummaryCardTitle/SummaryCardTitle';
import { SummaryCardProps } from 'pages/Optimisation/types';
import { useDynatraceTriggerAction } from 'utils/dynatrace';

const TooltipElement = () => {
  useDynatraceTriggerAction(DYNATRACE_ACTIONS.TOOLTIP_TOTAL_REVENUE);
  return (
    <>
      <p>
        Your indicative revenue from this site's booked trades during the time
        period selected. These are estimations only.
      </p>
      <br />
      <p>
        Please note this amount assumes 100% asset delivery performance. It does
        not include Embedded Benefits, imbalance charges or penalties.
      </p>
    </>
  );
};

export const TotalRevenueCard = ({
  data,
  loading,
  marketFilter,
}: SummaryCardProps) => {
  const revenue =
    data?.site?.tradeSummary?.[marketFilter as string]?.revenue || 0;
  const formattedRevenue = Math.round(Math.abs(revenue)).toLocaleString();
  const sign = revenue < 0 ? '-' : '';

  return (
    <CardStyled size={Sizes.Small}>
      <SummaryCardWrapper>
        <SummaryCardTitle
          title={'Net total revenue'}
          tooltip={<TooltipElement />}
        />

        <SummaryCardMainText data-testid="summary-card-main-text">
          {!data || loading ? (
            <div style={{ marginTop: 12 }}>
              <Skeleton data-testid="skeleton" width="230px" height="35px" />
            </div>
          ) : (
            <Flexbox alignItems={'baseline'}>
              {sign}
              <SuffixPrefix style={{ marginLeft: 2 }}>£</SuffixPrefix>
              {formattedRevenue}
            </Flexbox>
          )}
        </SummaryCardMainText>
      </SummaryCardWrapper>
    </CardStyled>
  );
};
